import React, { useState, useEffect } from "react";
import IntegracaoTable from "./IntegracaoTable";
import { useDispatch, useSelector } from "react-redux";
import { withNamespaces } from "react-i18next";
import { Card, Form } from "react-bootstrap";
import SpinnerNew from "~/components/SpinnerNew";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import FilterToogle from "./FilterToogle";
import Filters from "./Filters";
import {
  getGroupUsers,
  getIntegrationUsers,
  exportIntegrationUsers,
  integrateIntegrationUsers,
  setExportIntegrationUsers,
  setIntegrateIntegrationUsers,
} from "~/store/ducks/portalrh/actionTypes";
import moment from "moment";

const RHIntegracao = ({ t }) => {
  const dispatch = useDispatch();

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("");
  const [active, setActive] = useState(true);
  const [currentList, setCurrentList] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [checkboxes, setCheckboxes] = useState({});
  const [usersListSelected, setusersListSelected] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [groupSelected, setGroupSelected] = useState(null);

  useEffect(() => {
    const typeData = "AT";
    dispatch(getGroupUsers(typeData));
  }, []);

  const {
    groupUsers,
    isLoadingGetGroupUsers,
    integrationUsersList,
    exportIntegrationUsersList,
    integrateIntegrationUsersList,
    isLoadingIntegrate,
    isLoadingIntegrationUsers,
  } = useSelector((state) => state.portalrhReducer);

  useEffect(() => {
    if (integrationUsersList && integrationUsersList.length > 0) {
      setCurrentList(integrationUsersList);
    } else {
      setCurrentList([]);
    }
  }, [integrationUsersList]);

  useEffect(() => {
    const handleToast = (resetState, type, successMessage, errorMessage) => {
      if (type !== "") {
        if (resetState && type === "success") {
          setCurrentList([]);
        }
        setShowToast(true);
        setToastMessage(type === "success" ? successMessage : errorMessage);
        setToastType(type);
      }
    };

    handleToast(
      false,
      exportIntegrationUsersList,
      t("portalrh.rhadmin.integracao.sucessExporting"),
      t("portalrh.rhadmin.integracao.errorExporting")
    );
    handleToast(
      true,
      integrateIntegrationUsersList,
      t("portalrh.rhadmin.integracao.sucessIntegrating"),
      t("portalrh.rhadmin.integracao.errorIntegrating")
    );
  }, [exportIntegrationUsersList, integrateIntegrationUsersList]);

  const handleCloseWarning = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setShowToast(false);
    setToastMessage("");
    setToastType("");
    dispatch(setExportIntegrationUsers(""));
    dispatch(setIntegrateIntegrationUsers(""));
  };

  const handleActive = (active) => {
    setActive(active);
  };

  function buildGrouUserList() {
    const newArray = [];
    newArray.push({
      key: "all",
      label: t("portalrh.abscenses.all"),
      value: t("portalrh.abscenses.all"),
      selected: false,
    });
    if (groupUsers) {
      groupUsers.forEach((groupUser, index) => {
        newArray.push({
          key: `group-${index}`, // Chave única baseada no índice
          label: groupUser?.grupo?.designacao,
          value: groupUser?.grupo?.designacao,
          selected: false,
        });
      });
    }

    return newArray;
  }

  function handleDropdownSelect(submitValue) {
    setCurrentList([]);
    setSelectAll(false);
    setCheckboxes({});
    let newArray = [];

    if (submitValue === t("portalrh.abscenses.all")) {
      groupUsers.forEach((groupUser) => {
        const userNumFuncionarioList = groupUser?.userList || [];
        newArray.push(...userNumFuncionarioList);
      });
    } else {
      const selectedGroup = groupUsers.find(
        (groupUser) => submitValue === groupUser?.grupo?.designacao
      );
      if (selectedGroup) {
        const userNumFuncionarioList = selectedGroup?.userList || [];
        newArray.push(...userNumFuncionarioList);
      }
    }
    setusersListSelected(newArray);
    setGroupSelected(submitValue);
  }

  const dateFormatter = (cell, row, rowIndex, formatExtraData) => {
    if (cell) {
      const date = moment(cell, "YYYY-MM-DD HH:mm:ss.S").format("DD-MM-YYYY");

      return date;
    }
  };

  const hourFormatter = (cell) => {
    return cell ? moment(cell, "YYYY-MM-DD HH:mm:ss").format("HH:mm") : "";
  };

  const checkToExport = (cell, row, rowIndex, formatExtraData) => {
    return (
      <Form.Check
        key={`checkbox-${row.id}`} // Add a unique key here
        type="checkbox"
        label=""
        id={rowIndex}
        checked={formatExtraData.value[row.id] || false}
        onChange={(e) => handleCheckboxChange(e, row, formatExtraData)}
      />
    );
  };

  const columns = [
    {
      dataField: "id",
      hidden: true,
    },
    {
      dataField: "data",
      text: t("portalrh.rhadmin.integracao.data"),
      sort: true,
      type: "string", // Alterado de "text" para "string"
      formatter: dateFormatter,
    },
    {
      dataField: "dataInicio",
      text: t("portalrh.rhadmin.integracao.startDate"),
      sort: true,
      type: "string", // Alterado de "text" para "string"
      formatter: hourFormatter,
    },
    {
      dataField: "dataFim",
      text: t("portalrh.rhadmin.integracao.endDate"),
      sort: true,
      type: "string", // Alterado de "text" para "string"
      formatter: hourFormatter,
    },
    {
      dataField: "numeroFuncionario",
      text: t("portalrh.rhadmin.integracao.numeroFuncionario"),
      sort: true,
      type: "string", // Alterado de "text" para "string"
    },
    {
      dataField: "codigoEmpresa",
      text: t("portalrh.rhadmin.integracao.codigoEmpresa"),
      sort: true,
      type: "string", // Alterado de "text" para "string"
    },
    {
      dataField: "username",
      text: t("portalrh.rhadmin.integracao.username"),
      sort: true,
      type: "string", // Alterado de "text" para "string"
    },
    {
      dataField: "nomeCurto",
      text: t("portalrh.rhadmin.integracao.nomeCurto"),
      sort: true,
      type: "string", // Alterado de "text" para "string"
    },
    {
      dataField: "tempoInjustificado",
      text: t("portalrh.rhadmin.integracao.tempoInjustificado"),
      sort: true,
      type: "string", // Alterado de "text" para "string"
    },
    {
      dataField: "exportar",
      text: t("portalrh.rhadmin.integracao.exportar"),
      sort: false,
      headerStyle: { width: "fit-content", textAlign: "center" },
      formatter: checkToExport,
      formatExtraData: {
        value: checkboxes,
      },
      style: { textAlign: "center" },
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => {
        return (
          <div
            key={`header-${colIndex}`} // Add a unique key here
            style={{
              display: "inline-flex",
              flexDirection: "row-reverse",
              gap: "0.6rem",
            }}
          >
            <Form.Check
              type="checkbox"
              label=""
              id="selectAll"
              checked={selectAll}
              onChange={handleAllCheckboxesChange}
              disabled={currentList.length === 0}
            />
            {column.text}
            {sortElement}
            {filterElement}
          </div>
        );
      },
    },
  ];

  const handleCheckboxChange = (e, row, formatExtraData) => {
    setCheckboxes({
      ...checkboxes,
      [row.id]: e.target.checked,
    });
  };

  const handleAllCheckboxesChange = (event) => {
    setSelectAll(event.target.checked);
    setCheckboxes(
      currentList.reduce((result, row) => {
        result[row.id] = event.target.checked;
        return result;
      }, {})
    );
  };
  const handleCall = (type) => {
    const selectedUsers = currentList.filter((row) => checkboxes[row.id]);

    const payload = {
      dataInicio: startDate,
      dataFim: endDate,
      users: usersListSelected,
    };

    if (!startDate || !endDate || !groupSelected) {
      setToastMessage(t("portalrh.rhadmin.integracao.fieldsRequired"));
      setShowToast(true);
      setToastType("warning");
      return;
    }

    switch (type) {
      case "1":
        dispatch(getIntegrationUsers(payload));
        break;
      case "2":
        if (selectedUsers.length < 1) {
          setToastMessage(t("portalrh.rhadmin.integracao.noSelectedUsers"));
          setShowToast(true);
          setToastType("warning");
          return;
        }
        dispatch(exportIntegrationUsers(selectedUsers));
        break;
      case "3":
        if (selectedUsers.length < 1) {
          setToastMessage(t("portalrh.rhadmin.integracao.noSelectedUsers"));
          setShowToast(true);
          setToastType("warning");
          return;
        }
        dispatch(integrateIntegrationUsers(selectedUsers));
        break;
      default:
        break;
    }
  };

  return (
    <div className="main-card-v2" style={{ height: "fit-content" }}>
      <SpinnerNew
        open={
          isLoadingGetGroupUsers ||
          isLoadingIntegrate ||
          isLoadingIntegrationUsers
        }
        text={
          isLoadingIntegrationUsers
            ? t("portalrh.rhadmin.integracao.gettingList")
            : isLoadingIntegrate
            ? t("portalrh.rhadmin.integracao.integrating")
            : ""
        }
      />
      <Snackbar
        open={showToast}
        autoHideDuration={5000}
        onClose={handleCloseWarning}
      >
        <Alert
          onClose={handleCloseWarning}
          severity={toastType}
          sx={{ width: "100%" }}
        >
          {toastMessage}
        </Alert>
      </Snackbar>
      <Card bsPrefix="card-flat">
        <Card.Header className="justify-content-between">
          <h6>{t("portalrh.rhadmin.integracao.cardTitle")}</h6>
        </Card.Header>
        <Card.Body>
          <div>
            <>
              <FilterToogle handleActive={handleActive} active={active} />
              <Filters
                active={active}
                handleCall={handleCall}
                buildGrouUserList={buildGrouUserList}
                handleDropdownSelect={handleDropdownSelect}
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
                groupSelected={groupSelected}
                setGroupSelected={setGroupSelected}
              />
            </>
          </div>
          <IntegracaoTable
            currentList={currentList}
            columns={columns}
            handleCall={handleCall}
          />
        </Card.Body>
      </Card>
    </div>
  );
};

export default withNamespaces()(RHIntegracao);
